var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignupcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1574 8.39455H25.834L23.7494 4.89251C23.5455 4.55011 23.1765 4.34033 22.778 4.34033H16.2217C15.8232 4.34033 15.4542 4.55011 15.2503 4.89251L13.1657 8.39455H9.77817V7.62269C9.77817 6.99843 9.27206 6.49232 8.6478 6.49232H4.46528C3.84089 6.49232 3.3349 6.99843 3.3349 7.62269V8.39455H2.8425C1.27251 8.39455 0 9.66719 0 11.2369V31.8172C0 33.387 1.27251 34.6597 2.84237 34.6597H36.1574C37.7272 34.6597 38.9999 33.387 38.9999 31.8172V11.2369C39 9.66719 37.7272 8.39455 36.1574 8.39455ZM19.4999 29.6178C15.0314 29.6178 11.4091 25.9955 11.4091 21.5269C11.4091 17.0586 15.0314 13.4361 19.4999 13.4361C23.9683 13.4361 27.5907 17.0586 27.5907 21.5269C27.5907 25.9955 23.9683 29.6178 19.4999 29.6178ZM34.384 14.2547H30.8419C30.2177 14.2547 29.7116 13.7486 29.7116 13.1242C29.7116 12.4998 30.2177 11.9937 30.8419 11.9937H34.384C35.0085 11.9937 35.5145 12.4998 35.5145 13.1242C35.5145 13.7486 35.0083 14.2547 34.384 14.2547Z",
    fill: "#0A8A95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4999 27.1793C22.6216 27.1793 25.1521 24.6487 25.1521 21.527C25.1521 18.4054 22.6216 15.8748 19.4999 15.8748C16.3783 15.8748 13.8477 18.4054 13.8477 21.527C13.8477 24.6487 16.3783 27.1793 19.4999 27.1793Z",
    fill: "#0A8A95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupcamera);
export default __webpack_public_path__ + "static/media/signupcamera.d641409890460b26f22e166879ed8eda.svg";
export { ForwardRef as ReactComponent };